package org.example.project.model

enum class CellState {
    EMPTY,
    SHIP,
    HIT,
    MISS
}